import { useContext, useState } from "react";
import AppButton from "../button/button";
import { CrossSVGIcon } from "../../../assets/reactSVGIcon/CrossSVGIcon";
import { iGlobalContext } from "../../../context/globalContext/interface";
import { StateContext } from "../../../context/globalContext/context";
import { colors } from "../../../styles/design-tokens";

export default function CloseDialogBtn({ onClose }: { onClose: any }) {
  const { isMobile }: iGlobalContext = useContext(StateContext);
  const [crossIconColor, setCrossIconColor] = useState<string>(colors.neutral.white);
  return (
    <AppButton
      onClick={() => {
        onClose();
        if (!isMobile) setCrossIconColor(colors.neutral.white);
      }}
      btnText=""
      variant="transparent"
      translateY={-2}
      onMouseEnter={() => {
        if (!isMobile) setCrossIconColor(colors.neutral.darker);
      }}
      onMouseLeave={() => {
        if (!isMobile) setCrossIconColor(colors.neutral.white);
      }}
      svgIcon={<CrossSVGIcon fill={crossIconColor} height="20" />}
    />
  );
}
